import { sleep } from '@ipfabric/ui-components/utils/sleep';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import { logout } from 'components/GlobalState/commands/logout';
import { useLocale } from 'containers/App/LocaleContext';
import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import { type FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIpfLocation } from 'utils/history/useIpfLocation';

export const Logout: FC = () => {
  const ctxProps = useGlobalStateContextSelectors({
    dispatch: prop('dispatch'),
  });
  const navigate = useNavigate();
  const { state } = useIpfLocation();
  const msg = useLocale();

  const logoutUser = async () => {
    ctxProps.dispatch(logout);
    await sleep(0);
    navigate('/login', { state: { nextPathName: state?.nextPathName } });
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: called just once on mount
  useEffect(() => {
    logoutUser();
  }, []);

  return <LoaderAndText bottomText={msg.auth.loggingOut} />;
};
